import type { FormatedProductPrice } from "@dransay/api";
import { useTranslation } from "react-i18next";
import { ProductCarousel } from "~/components/product-carousel.component";
import { ExclusiveProductsCompactSection } from "./exclusive-products-compact-section.component";
import { getExclusivePdpLayoutVariant } from "./exclusive-products-pdp.logic";
import {
	getExclusivePdpTitleInterpolationOptions,
	getExclusivePdpTitleTranslationKey,
} from "./get-exclusive-pdp-title";

interface ExclusiveProductsPdpSectionProps {
	products: FormatedProductPrice[];
}

export function ExclusiveProductsPdpSection({
	products,
}: ExclusiveProductsPdpSectionProps) {
	const { t } = useTranslation("product");
	const layoutVariant = getExclusivePdpLayoutVariant(products.length);
	if (layoutVariant === "hidden") {
		return null;
	}
	if (layoutVariant === "compact") {
		return <ExclusiveProductsCompactSection products={products} />;
	}
	const count = products.length;
	const mobileTitle = t(
		getExclusivePdpTitleTranslationKey(count, true),
		getExclusivePdpTitleInterpolationOptions(count, true),
	);
	const desktopTitle = t(
		getExclusivePdpTitleTranslationKey(count, false),
		getExclusivePdpTitleInterpolationOptions(count, false),
	);
	return (
		<div className="md:max-w-full" data-testid="exclusive-products-pdp-section">
			<ProductCarousel
				products={products}
				variant="productPage"
				mobileTitle={mobileTitle}
				desktopTitle={desktopTitle}
			/>
		</div>
	);
}
